import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import styles
import config from "../../config";

export default function NewsUpload() {
  const initialFormData = {
    Title: "",
    ShortDesc: "",
    StatusId: "",
    PostDate: "",
    LanguageId: "",
    userId: "",
    ImageUrl: "",
  };
  const [formData, setFormData] = useState(initialFormData);
  const [richtext, setRichtext] = useState(null);
  const [responseMessage, setResponseMessage] = useState("");
  const [showResponse, setShowResponse] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);

  const [subcategories, setSubcategories] = useState([]);
  const [selectedSubcategory, setSelectedSubcategory] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleTextChange = (text) => {
    setRichtext(text);
  };

  const clearForm = () => {
    setFormData(initialFormData);
  };

  useEffect(() => {
    fetchSubcategories();
  }, []);

  const fetchSubcategories = async () => {
    try {
      const response = await fetch(
        `${config.apiUrl}contentapi.php?option=1&type=4&categoryid=4&subcategory=0`
      );
      const subcategoriesData = await response.json();
      setSubcategories(subcategoriesData);
      setSelectedSubcategory("");
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };

  const subcategorySelect = subcategories.map((subcategory) => (
    <option key={subcategory.id} value={subcategory.id}>
      {subcategory.SubCategoryd}
    </option>
  ));

  const handleSubmit = (e) => {
    e.preventDefault();

    // Create a new FormData object
    const formData2 = new FormData();

    // Append the form data fields to the FormData object
    formData2.append("Title", formData.Title);
    formData2.append("ShortDesc", formData.ShortDesc);
    formData2.append("StatusId", formData.StatusId);
    formData2.append("LanguageId", formData.LanguageId);
    formData2.append("userId", formData.userId);
    formData2.append("ImageUrl", formData.ImageUrl);

    formData2.append("fulldesc", richtext);

    formData2.append("category", "4");
    formData2.append("subcategory", selectedSubcategory);

    // Send form data to the server
    fetch(`${config.apiUrl}uploadapi.php?type=3`, {
      method: "POST",
      body: formData2,
      credentials: "include",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok.");
        }
        return response.json();
      })
      .then((data) => {
        // Show the response message temporarily
        setResponseMessage(data.message);
        setShowResponse(true);

        // Clear the form after successful submission
        clearForm();

        // Hide the response message after 5 seconds
        setTimeout(() => {
          setShowResponse(false);
          setResponseMessage("");
        }, 5000);
      })
      .catch((data) => {
        // Handle any errors that occurred during the API request
        setErrorMessage(data.error);
        setShowError(true);

        console.log(data, "error message");
        // Hide the response message after 5 seconds
        setTimeout(() => {
          setShowError(false);
          setErrorMessage("");
        }, 5000);
      });
  };

  const modules = {
    toolbar: [
      ["bold", "italic", "underline", "strike"], // toggled buttons
      ["blockquote", "code-block"],

      [{ header: 1 }, { header: 2 }], // custom button values
      [{ list: "ordered" }, { list: "bullet" }],
      [{ script: "sub" }, { script: "super" }], // superscript/subscript
      [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
      [{ direction: "rtl" }], // text direction

      [{ size: ["small", false, "large", "huge"] }], // custom dropdown
      [{ header: [1, 2, 3, 4, 5, 6, false] }],

      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      [{ font: [] }],
      [{ align: [] }],

      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "code-block",
    "list",
    "bullet",
    "indent",
    "script",
    "sub",
    "super",
    "direction",
    "link",
    "image",
    "color",
    "font",
    "size",
    "align",
  ];

  return (
    <div>
      <form onSubmit={handleSubmit} dir="rtl" style={{ fontSize: "smaller" }}>
        <div className="form-group row g-3">
          <div className="col-lg-6">
            <label htmlFor="category" className="form-label">
              Category
            </label>
            <select
              id="selectCategory"
              required
              name="category"
              value="5"
              className="form-select"
              aria-label="Disabled select example"
              disabled
            >
              <option>نیوز</option>
            </select>
          </div>
          <div className="col-lg-6">
            <label htmlFor="subcategory" className="form-label">
              Subcategory
            </label>
            <select
              id="selectSubcategory"
              required
              name="subcategory"
              value={formData.subcategory}
              onChange={(e) => setSelectedSubcategory(e.target.value)}
              className="form-select"
            >
              <option>Select a subcategory</option>
              {subcategorySelect}
            </select>
          </div>
          <hr />
          <div className="col-lg-6">
            <label htmlFor="title" className="form-label">
              Title
            </label>
            <input
              type="text"
              className="form-control"
              id="Title"
              value={formData.Title}
              onChange={handleChange}
              name="Title"
              required
              disabled={!selectedSubcategory}
            />
          </div>
          <div className="col-lg-6">
            <label htmlFor="StatusId" className="form-label">
              Publish
            </label>
            <select
              name="StatusId"
              value={formData.StatusId}
              onChange={handleChange}
              className="form-select"
              required
              disabled={!selectedSubcategory}
            >
              <option>Select publish status</option>
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
          <div className="col-lg-12">
            <label htmlFor="ShortDesc" className="form-label">
              Short Description
            </label>
            <textarea
              rows={3}
              className="form-control"
              name="ShortDesc"
              id="ShortDesc"
              value={formData.ShortDesc}
              onChange={handleChange}
              required
              disabled={!selectedSubcategory}
            ></textarea>
          </div>
          <div className="col-lg-4">
            <label htmlFor="ImageUrl" className="form-label">
              Image
            </label>
            <input
              dir="ltr"
              type="text"
              className="form-control"
              id="ImageUrl"
              value={formData.ImageUrl}
              onChange={handleChange}
              name="ImageUrl"
              required
              disabled={!selectedSubcategory}
            />
          </div>
          <div className="col-lg-4">
            <label htmlFor="youtubeUrl" className="form-label">
              Language
            </label>
            <select
              name="LanguageId"
              value={formData.LanguageId}
              onChange={handleChange}
              className="form-select"
              required
              disabled={!selectedSubcategory}
            >
              <option>Select a language</option>
              <option value="1">Dari</option>
              <option value="2">Pashto</option>
            </select>
          </div>
          <div className="col-lg-12">
            <label htmlFor="fulldesc" className="form-label">
              Full Description
            </label>
            <ReactQuill
              theme="snow"
              value={richtext}
              onChange={handleTextChange}
              modules={modules}
              formats={formats}
            />
          </div>
        </div>
        {showResponse && (
          <div className="alert alert-success my-2">{responseMessage}</div>
        )}
        {showError && (
          <div className="alert alert-danger my-2">{errorMessage}</div>
        )}
        <div
          className="d-flex justify-content-end gap-2"
          style={{ marginTop: "1em" }}
        >
          <input
            className="btn btn-secondary"
            type="reset"
            value="Clear form"
            onClick={() => clearForm()}
          />
          <button
            type="submit"
            className="btn btn-primary"
            disabled={!selectedSubcategory}
          >
            Upload
          </button>
        </div>
      </form>
    </div>
  );
}
